import AvatarList, {
  AVATAR_DISPLAY_LIMIT,
} from "@domains/common/views/components/AvatarList/AvatarList";
import useModalState from "@logics/hooks/useModalState";
import EventViewModel from "@domains/event/viewModel/EventViewModel";
import { useAuthSession } from "@domains/auth/hooks/useAuthSession";

import AvatarListBottomSheet from "../../components/AvatarListBottomSheet/AvatarListBottomSheet";

import * as S from "./AvatarListSection.style";

interface AvatarListSectionProps {
  participant: EventViewModel["participant"];
  hostId: EventViewModel["host"]["id"];
}

const AvatarListSection = ({ participant, hostId }: AvatarListSectionProps) => {
  const { openModal } = useModalState();
  const { guardRoute } = useAuthSession();

  const handleClickAvatarList = () =>
    guardRoute(() => {
      openModal({
        CustomComponent: (
          <AvatarListBottomSheet hostId={hostId} participant={participant} />
        ),
      });
    });

  return (
    <S.AvatarSection onClick={handleClickAvatarList}>
      <AvatarList
        spaceBetween
        withBorder
        avatarDisplayLimit={AVATAR_DISPLAY_LIMIT.EVENT}
        avatarList={participant.list}
        additionalText={participant.displayCountText}
      />
    </S.AvatarSection>
  );
};

export default AvatarListSection;
